import { Button, CircularProgress, Container, Grid2 as Grid } from "@mui/material"
import { Body, Label } from "../../components/Typography/Typography"
import { useStyles } from "./styles"

interface LoadingScreenProps {
    body?: string
    button?: {
        label: string
        onClick: () => void
    }
    label: string
}

export const Loading = ({ body, label, button }: LoadingScreenProps) => {
    const { classes } = useStyles()

    return (
        <Container maxWidth="xs" className={classes.root}>
            <Grid
                container
                direction="column"
                justifyContent="center"
                alignContent="center"
                className={classes.wrapper}
            >
                {!body ? (
                    <>
                        <Grid className={classes.gutterBottom__sm}>
                            <CircularProgress />
                        </Grid>
                        {label && (
                            <Grid>
                                <Body>{label ?? "Loading..."}</Body>
                            </Grid>
                        )}
                    </>
                ) : (
                    <>
                        <Label gutterBottom="sm">{label}</Label>
                        <Body gutterBottom="md">{body}</Body>
                        {button && (
                            <Button variant="contained" color="primary" onClick={button.onClick}>
                                {button.label}
                            </Button>
                        )}
                    </>
                )}
            </Grid>
        </Container>
    )
}
